"use strict";
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderButton = void 0;
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const index_js_1 = require("../utils/index.js");
require("@itwin/itwinui-css/css/header.css");
const HeaderSplitButton_js_1 = require("./HeaderSplitButton.js");
const HeaderDropdownButton_js_1 = require("./HeaderDropdownButton.js");
const HeaderBasicButton_js_1 = require("./HeaderBasicButton.js");
const isSplitButton = (props) => {
    return !!props.menuItems && !!props.onClick;
};
const isDropdownButton = (props) => {
    return !!props.menuItems;
};
/**
 * Header button that handles slim state of the `Header` it's in.
 * When in slim mode, will only display the name and reduce icon size.
 * Will display an arrow on the right if `menuItems` prop is provided.
 * @example
 * <HeaderButton name='Project A' description='0n00434' menuItems={...} />
 * <HeaderButton name='Project B' description='0n00434' startIcon={<SvgImodelHollow />} />
 * <HeaderButton name='Project C' startIcon={<img style={{ objectFit: 'cover' }} src='project.png' />} />
 * <HeaderButton name='Project D' isActive />
 */
exports.HeaderButton = React.forwardRef((props, ref) => {
    const { name, description, isActive = false, className, startIcon, menuItems, disabled, ...rest } = props;
    (0, index_js_1.useTheme)();
    const buttonProps = {
        startIcon: React.isValidElement(startIcon)
            ? React.cloneElement(startIcon, {
                className: (0, classnames_1.default)('iui-header-breadcrumb-button-icon', startIcon.props.className),
            })
            : undefined,
        className: className,
        children: (React.createElement("span", { className: 'iui-header-breadcrumb-button-text' },
            React.createElement("span", { className: 'iui-header-breadcrumb-button-text-label' }, name),
            description && (React.createElement("span", { className: 'iui-header-breadcrumb-button-text-sublabel' }, description)))),
        ref: ref,
        disabled: disabled,
        ...(!!menuItems && { menuItems }),
        ...rest,
    };
    const headerButton = isSplitButton(buttonProps) ? (React.createElement(HeaderSplitButton_js_1.HeaderSplitButton, { ...buttonProps })) : isDropdownButton(buttonProps) ? (React.createElement(HeaderDropdownButton_js_1.HeaderDropdownButton, { ...buttonProps })) : (React.createElement(HeaderBasicButton_js_1.HeaderBasicButton, { ...buttonProps }));
    return (React.createElement("li", { className: 'iui-header-breadcrumb-item', "aria-current": isActive ? 'location' : undefined, "aria-disabled": disabled ? 'true' : undefined }, headerButton));
});
exports.default = exports.HeaderButton;
